<template>
    <section class="stations-functions">
        <div class="inner">
            <div
                v-for="(item, key) in functions"
                :key="`function-item-${key}`"
                class="item"
            >
                <h2 v-if="item.title" class="h5">{{ item.title }}</h2>
                <div class="content">
                    <component :is="item.component" />
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import { ref, computed, useI18n, onMounted, resolveComponent } from '#imports';
import { storeToRefs } from 'pinia';
import { usePageStore } from '~dsc/stores/cms/page';

const { station } = storeToRefs(usePageStore());
const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            carwash: 'Autopesu',
        },
    },
});

const services = computed(() => station.value.services.map(service => service.replace(/^finland\//, '').replace(/^sweden\//, '').replace(/^norway\//, '')) || null);
const open = ref('');

const functions = (computed(() => {
    const options = {};

    if (station.value.lunch) {
        options['lunch-list'] = {
            title: t('lunch-list'),
            component: resolveComponent('BlocksStationsFunctionsLunchList'),
        };
    }

    if (station.value.services?.length > 0) {
        options.services = {
            component: resolveComponent('BlocksStationsFunctionsAttributes'),
        };
    }

    if (station.value.menu) {
        options.food = {
            title: station.value.menu.title ?? t('food'),
            component: resolveComponent('BlocksStationsFunctionsFood'),
        };
    }

    if (services.value?.includes('perfectcarwash')
        || services.value?.includes('perfectcarwash24hours')
    ) {
        options.autopesu = {
            title: t('carwash'),
            component: resolveComponent('BlocksStationsFunctionsAutopesu'),
        };
    }

    return options || [];
}));

onMounted(() => {
    open.value = Object.keys(functions.value)[0] || '';
});
</script>
<script>

export default {
    name: 'StationsFunctions',
};
</script>
<style scoped>
.stations-functions {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.stations-functions .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}
.stations-functions:not(:last-child) {
  margin-bottom: 4rem;
}
.stations-functions .item {
  margin: 4rem;
}
.stations-functions .item .heading {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0;
  cursor: pointer;
}
.stations-functions .item .heading .h5 {
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;
  margin-bottom: 0;
}
.stations-functions .item.open .h5 {
  color: var(--color-primary-900);
}
.stations-functions .item.open:first-child {
  border-bottom-color: var(--color-base-white);
}

.fade-list {
  display: inline-flex;
  position: relative;
  width: 32px;
  height: 32px;
  align-items: center;
}
.fade-list .fade-enter {
  transition: all 0.2s ease-in-out;
  position: absolute;
  opacity: 0;
}
.fade-list .fade-leave-to {
  opacity: 0;
  position: absolute;
}
.fade-list .open-icons {
  color: var(--color-primary-900);
}
</style>
